export default __webpack_public_path__ + "static/media/ml.766ed557.svg";